import { Shadows, ThemeOptions } from '@mui/material';

const shadowList = [
  'none', // shadow-0
  '0px 2px 12px rgba(80, 89, 130, 0.16)', // shadow-1
  '0px 4px 16px rgba(5, 6, 49, 0.16)', // shadow-2
  '0px -6px 12px -6px rgba(80, 89, 130, 0.16)', // bottom-shadow-1
  '0px 2px 8px 0px rgb(5 6 49 / 14%)', // shadow-small
  ...new Array(22).fill('none'),
] as Shadows; // Исключение, так как new Array не возвращает в типе количество элементов

export const createShadows = (): Pick<ThemeOptions, 'shadows'> => {
  return {
    shadows: shadowList,
  };
};
